import { API_URL } from "../../utils/url-constants";
import axiosMain from "./intercepters";
import axioAdmin from "./admin-intercepters";
import axios from "axios";

//Generate Token
export async function getTempareyToken() {
  return await axiosMain?.get(
    `${API_URL?.userAuth.generateToken}`
  );
}

// session check api
export async function getCheckSession() {
  return await axiosMain?.get(
    `${API_URL?.userAuth.checkSessionApi}`
  );
}


// get event calander 
export async function checkUserSession() {
  return await axioAdmin?.get(
    `${API_URL?.userAuth?.getAllRoles}`
  );
}




// Generate pdf file
export async function generatePdfFile(applicationId) {
  return await axiosMain?.get(
    `${API_URL?.applyKendra?.generatePdf}?applicationId=${applicationId}`
  );
}

// Upload multipart single file
export async function uploadMultipartFile(file) {
  return await axiosMain?.post(`${API_URL?.uploadMultipartFile}`, file);
}

// Upload multipart multiple file
export async function uploadMultipartMultipleFile(file) {
  return await axiosMain?.post(`${API_URL?.uploadMultipartMultipleFile}`, file);
}


// Captcha Service
export async function postCaptcha(loginId) {
  return await axiosMain?.post(
    `${API_URL?.userAuth?.generateCapatch}?loginId=${loginId}`
  );
}

//Login Service
export async function postLogin(payload) {
  return await axiosMain?.post(`${API_URL?.userAuth?.login}`, payload);
}

//Registration Service
export async function postRegistration(payload) {
  return await axiosMain?.post(`${API_URL?.userAuth?.registration}`, payload);
}

// apply kendra basic detail service
export async function postApplyKendraForm(payload) {
  return await axiosMain?.post(
    `${API_URL?.applyKendra?.basicDetails}`,
    payload
  );
}
export async function getState() {
  return await axiosMain?.get(`${API_URL?.applyKendra?.state}`);
}
export async function getDistrict(stateId) {
  return await axiosMain?.get(
    `${API_URL?.applyKendra?.district}?id=${stateId}`
  );
}
export async function getBlock(districtId) {
  return await axiosMain?.get(
    `${API_URL?.applyKendra?.block}?districtId=${districtId}`
  );
}
export async function getApplicationByUserId(userid) {
  const encodedUserId = encodeURIComponent(userid);
  return await axiosMain?.get(
    `${API_URL?.myApplication?.byUserId}?userId=${encodedUserId}`
  );
}
export async function getUserApplicationStatus(applicationId) {
  return await axiosMain?.get(
    `${API_URL?.userStatus?.userStatus}?applicationId=${applicationId}`
  );
}
export async function getApplicationByApplicationId(appId, roleId = 0) {
  return await axiosMain?.get(
    `${API_URL?.myApplication?.newApplicationId}?applicationId=${appId}&type=${roleId}`
  );
}
// Aadhar Verify
export async function aadharSendOtp(body) {
  return await axiosMain?.post(`${API_URL?.aadhar?.sendOtp}`, body);
}
export async function aadharVerify(body) {
  return await axiosMain?.post(`${API_URL?.aadhar?.verify}`, body);
}
// apply Drug licence
export async function applyDrugLicenece(body) {
  return await axiosMain?.post(`${API_URL?.applyKendra?.drugLicence}`, body);
}
export async function postOtpGenerate(payload) {
  return await axiosMain?.post(`${API_URL?.userAuth?.otpGenerate}`, payload);
}

export async function postOtpVerification(payload) {
  return await axiosMain?.post(`${API_URL?.userAuth?.verifyOtp}`, payload);
}

export async function postResetPassword(payload) {
  return await axiosMain?.post(`${API_URL?.userAuth?.resetPassword}`, payload);
}
export async function postReSendOtp(payload) {
  return await axiosMain?.post(`${API_URL?.userAuth?.reSendOtp}`, payload);
}

// Admin End points
//admin Login Service
export async function AdminPostLogin(payload) {
  return await axioAdmin?.post(`${API_URL?.userAuth?.adminLogin}`, payload);
}
export async function getAdminApplicationByApplicationId(appId) {
  return await axioAdmin?.get(
    `${API_URL?.myApplication?.byApplicationId}?applicationId=${appId}`
  );
}
export async function getAdminApplicationByApplicationIdNew(appId, roleId) {
  return await axioAdmin?.get(
    `${API_URL?.myApplication?.newApplicationId}?applicationId=${appId}&type=${roleId}`
  );
}
// get  Job
export async function getJobList(payload) {
  return await axioAdmin?.post(`${API_URL?.recuritment.getListOfJob}`, payload);
}
// get  resume List
export async function getResumeList(payload) {
  return await axioAdmin?.post(
    `${API_URL?.recuritment.getListOfresume}`,
    payload
  );
}
// get new dashboard data change on 17 june 2025
export async function getDashboardData() {
  return await axioAdmin?.get(
    `${API_URL?.pmbiUser.getAdminDashboardData}`
  );
}
// delete Recruitment
export async function deleteRecruitList(id) {
  return await axioAdmin?.delete(`${API_URL?.recuritment?.deleteRecruitmentList}?jobId=${id}`);
}
export async function deleteResumeList(id) {
  return await axioAdmin?.delete(`${API_URL?.recuritment?.deleteResumeList}?resumeId=${id}`);
}
// get resume by id
export async function getResumeBYID(resumeid) {
  return await axioAdmin?.get(
    `${API_URL?.recuritment.getResumeById}?id=${resumeid}`
  );
}

// Post Job
export async function addUpdateJob(payload) {
  return await axioAdmin?.post(`${API_URL?.recuritment.addUpdateJob}`, payload);
}
// Post Job
export async function getJobListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.recuritment.getListOfJobWebSite}`, payload);
}
export async function getYearMonthWeb(payload) {
  return await axiosMain?.post(`${API_URL?.recuritment.getMonthYearList}`, payload);
}


// Post pmbi user
export async function addUpdateUser(payload) {
  return await axioAdmin?.post(`${API_URL?.pmbiUser?.addUpdateUser}`, payload);
}

// get role list
export async function getRoleList() {
  return await axioAdmin?.get(`${API_URL?.pmbiUser?.getrole}`);
}

//addjob
export async function applyJob(payload) {
  return await axioAdmin?.post(`${API_URL?.recuritment?.applyjob}`, payload);
}

export async function getJobById(id) {
  return await axioAdmin?.get(`${API_URL?.recuritment?.getJobById}?id=${id}`);
}

// get  admin user list
export async function getadminuserList(payload) {
  return await axioAdmin?.post(
    `${API_URL?.pmbiUser?.getAllAdminUser}`,
    payload
  );
}

// get view application list
export async function getkendraAppliedList(payload) {
  return await axioAdmin?.post(`${API_URL?.pmbiUser?.getAllKendra}`, payload);
}


// get view application list
export async function getkendraAppliedListWithSubCategory(payload) {
  return await axioAdmin?.post(`${API_URL?.pmbiUser?.getAllKendrawithsubCategory}`, payload);
}


// get view application list super admin
export async function getkendraAppliedListSuperAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.pmbiUser?.getAllKendraSuperAdmin}`,
    payload
  );
}

// get view application list super admin
export async function getkendraAppliedListExport(payload) {
  return await axioAdmin?.post(
    `${API_URL?.pmbiUser?.exportsApplication}`,
    payload
  );
}

// get view application list super admin
export async function getMISExport(payload) {
  return await axioAdmin?.post(
    `${API_URL?.pmbiUser?.misReport}`,
    payload
  );
}


export async function applicationApprove(payload) {
  return await axioAdmin?.post(
    `${API_URL?.pmbiUser?.applicationApproval}`,
    payload
  );
}

export async function applicationRejectFromAdminOrL4(payload) {
  return await axioAdmin?.post(
    `${API_URL?.pmbiUser?.applicationRejection}`,
    payload
  );
}

export async function getAdminState() {
  return await axioAdmin?.get(`${API_URL?.applyKendra?.state}`);
}
export async function getAdminById(roleId) {
  return await axioAdmin?.get(`${API_URL?.applyKendra?.adminById}?id=${roleId}`);
}
export async function getAdminDistrict(stateCode) {
  return await axioAdmin?.get(
    `${API_URL?.applyKendra?.district}?stateCode=${stateCode}`
  );
}

export async function getAdminDistrictByStateID(stateId) {
  return await axioAdmin?.get(
    `${API_URL?.applyKendra?.districtByStateId}?id=${stateId}`
  );
}

export async function getAdminDistrictByStateCode(stateCode) {
  return await axioAdmin?.get(
    `${API_URL?.pmbiUser.districtByStateCode}?id=${stateCode}`
  );
}

export async function getAdminBlock(districtCode) {
  return await axioAdmin?.get(
    `${API_URL?.applyKendra?.block}?districtId=${districtCode}`
  );
}

export async function adminStatusChange(statusChangeObj) {
  return await axioAdmin?.get(
    `${API_URL?.pmbiUser?.changeStatus}?id=${statusChangeObj?.id}&status=${statusChangeObj?.status}`
  );
}
// cheque number
export async function postCheckNumber(body) {
  return await axiosMain?.post(`${API_URL?.initialLetter?.chequeNumber}`, body);
}
//request for extension letter
export async function extensionLetter(body) {
  return await axiosMain?.post(`${API_URL?.extension?.initialLetter}`, body);
}
export async function extensionProposedKendra(body) {
  return await axiosMain?.post(`${API_URL?.extension?.proposedKendra}`, body);
}
// get  Tender list
export async function getTenderList(payload) {
  return await axioAdmin?.post(`${API_URL?.tender?.getTenderList}`, payload);
}
// Delete tender
export async function deleteList(id, apiUrl) {
  return await axioAdmin?.delete(`${API_URL?.tender?.deleteTenderList}/${apiUrl}?id=${id}`);
}

// get  Tender list website
export async function getTenderListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.tender?.getTenderList}`, payload);
}
export async function getBlackListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.blacklist?.getBlackList}`, payload);
}
export async function getDebarredListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.debarred?.getDebarredList}`, payload);
}
export async function getAwarededListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.awarded?.getAwardedList}`, payload);
}
export async function getRevocationListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.revocation?.getRevocationList}`, payload);
}
// tender status change
export async function TenderStatusChange(statusChangeObj) {
  return await axioAdmin?.get(
    `${API_URL?.tender.changeStatus}?id=${statusChangeObj?.id}&status=${statusChangeObj?.status}`
  );
}


// get Debarrded Tender list
export async function getDebarrdedTenderList(payload) {
  return await axioAdmin?.post(`${API_URL?.tender?.getDebarrdedTenderList}`, payload);
}

// add Debarrded
export async function addDebarrdedFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.tender.addDebarrded}`, payload
  );
}


// add Debarrded
export async function addRevocationFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.tender.addRevocation}`, payload
  );
}
// add Black List
export async function addBlackFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.tender.addBlackList}`, payload
  );
}

// add awarded list
export async function addAwardedFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.tender.addAwardedList}`, payload
  );
}

// add awarded list
export async function updateAwardedFromAdmin(payload) {
  return await axioAdmin?.put(
    `${API_URL?.tender.updateAwardedList}`, payload
  );
}
// get Black Tender list
export async function getBlackTenderList(payload) {
  return await axioAdmin?.post(`${API_URL?.tender?.getBlackTenderList}`, payload);
}
// get awarded Tender list
export async function getAwardedTenderList(payload) {
  return await axioAdmin?.post(`${API_URL?.tender?.getAwardedTenderList}`, payload);
}

// get Revocation Tender list
export async function getRevocationTenderList(payload) {
  return await axioAdmin?.post(`${API_URL?.tender?.getRevocationTenderList}`, payload);
}
export async function getAdminStateByAdminId(adminid) {
  return await axioAdmin?.post(
    `${API_URL?.applyKendra?.statebyAdminId}?adminId=${adminid}`
  );
}

export async function getApplicationByID(applicationID) {
  return await axioAdmin?.get(
    `${API_URL?.applyKendra?.applicationgetbyID}?applicationId=${applicationID}`
  );
}
export async function generateInitialLetterWithDSC(applicationId, loginAdminID) {
  return await axioAdmin?.get(
    `${API_URL?.applyKendra?.generateInitialPdf}?applicationId=${applicationId}&adminLoginId=${loginAdminID}`
  );
}
export async function generateFinalLetterWithDSC(kendraCode, applicationId, loginAdminID) {
  return await axioAdmin?.get(
    `${API_URL?.applyKendra?.generateFinalPdf}?applicationId=${applicationId}&finalKendraCode=${kendraCode}&adminLoginId=${loginAdminID}`
  );
}




export async function updateDscLetter(payload) {
  return await axioAdmin?.post(`${API_URL?.applyKendra?.updatedscletter}`, payload
  );
}

export async function getDashboardCount(payload) {
  return await axioAdmin?.post(
    `${API_URL?.dashboard?.count}`, payload
  );
}

// Post Tender
export async function addTender(payload) {
  return await axioAdmin?.post(`${API_URL?.tender?.addTender}`, payload);
}

// Put Tender
export async function UpdateTender(payload) {
  return await axioAdmin?.put(`${API_URL?.tender?.updateTender}`, payload);
}
//post pharama details
export async function postAllPharmacist(payload) {
  return await axiosMain?.post(
    `${API_URL?.pharmacist?.allPharmacist}`,
    payload
  );
}
export async function postRegisterPharmacist(payload) {
  return await axiosMain?.post(
    `${API_URL?.pharmacist?.pharmacistRegister}`,
    payload
  );
}

//payment
export async function getPaymentStatus(orderId) {
  return await axiosMain?.get(
    `${API_URL?.payment?.paymentStatus}?orderId=${orderId}`
  );
}
export async function postCreateOrderId(payload) {
  return await axiosMain?.post(`${API_URL?.payment?.orderId}`, payload);
}
//all distributor
export async function postAllDistributor(payload) {
  return await axiosMain?.post(`${API_URL?.distributor?.getdistributorList}`, payload);
}

// get pharmacist list
export async function getpharmauserList(payload) {
  return await axioAdmin?.post(
    `${API_URL?.pharmacist?.getAllPharmaCist}`,
    payload
  );
}
// get product list

export async function getAllProduct(body) {
  return await axiosMain?.post(`${API_URL?.product.porductlist}`, body);
}
export async function getAllProductPortfolio(body) {
  return await axiosMain?.post(`${API_URL?.product.porductportfoliolist}`, body);
}

export async function searchProducts(payload) {
  return await axiosMain?.post(`${API_URL?.product?.searchProduct}`, payload);
}
// Upload agreement
export async function uploadAgreementUrl(url, appId) {
  return await axiosMain?.post(
    `${API_URL?.applyKendra?.uploadAgreement}?uploadAgreementUrl=${url}&applicationId=${appId}`,
  );
}


// get  product list
export async function getProductList(payload) {
  return await axioAdmin?.post(`${API_URL?.product.porductlist}`, payload);
}

// add product 
export async function addProductFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.product.addProduct}`, payload
  );
}
// product status change
export async function ProductStatusChange(statusChangeObj) {
  return await axioAdmin?.post(
    `${API_URL?.product.changeStatus}`, statusChangeObj
  );
}
// product delete
export async function productDelete(productid) {
  return await axioAdmin?.delete(
    `${API_URL?.product.deleteproduct}?id=${productid}`
  );
}
// Bulk product delete
export async function BulkproductDelete(productids) {
  return await axioAdmin?.delete(
    `${API_URL?.product.bulkdeleteproduct}`, { data: productids }
  );
}
// get  contact list website
export async function getWebsiteContact(payload) {
  return await axiosMain?.post(`${API_URL?.contact?.contactList}`, payload);
}

// get  contact list
export async function getContactList(payload) {
  return await axioAdmin?.post(`${API_URL?.contact?.contactListAdmin}`, payload);
}


// add contact
export async function addContactFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.contact.addContact}`, payload
  );
}
// contact status change & delete contact list
export async function ContactStatusChange(statusChangeObj) {
  return await axioAdmin?.get(
    `${API_URL?.contact.changeStatus}?id=${statusChangeObj.id}&status=${statusChangeObj.status}`
  );
}

// bulk delete contact us
export async function BulkContactDelete(contactIds) {
  return await axioAdmin?.delete(
    `${API_URL?.contact.bulkDeleteContact}`, { data: contactIds }
  );
}

// add contact
export async function addLocatorFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.locator.addLocator}`, payload
  );
}

// get  locator list
export async function getLocatorList(payload) {
  return await axioAdmin?.post(`${API_URL?.locator.getlocatorList}`, payload);
}
// bulk delete locator list
export async function BulkLocatorDelete(locatorIds) {
  return await axioAdmin?.delete(
    `${API_URL?.locator.bulkDeleteLocator}`, { data: locatorIds }
  );
}

// contact status change
export async function locatorStatusChange(statusChangeObj) {
  return await axioAdmin?.get(
    `${API_URL?.locator.changestatus}?id=${statusChangeObj.id}&status=${statusChangeObj.status}`
  );
}
//  upload locator/kendra/product vai file

export async function uploadCSV(apiurl, file) {
  return await axioAdmin?.post(apiurl, file);
}

//  //  Governencve  
export async function getGoverningCouncil(payload) {
  return await axiosMain?.post(
    `${API_URL?.Governance.getGoverningCouncil}`, payload
  );
}

export async function getAllExecutiveCouncil(payload) {
  return await axiosMain?.post(
    `${API_URL?.Governance.getAllExecutiveCouncil}`, payload)
}

export async function getAllMangementTeam(payload) {
  return await axiosMain?.post(
    `${API_URL?.Governance.getManagmentTeam}`, payload)
}
// kendra get 
export async function getKendraList(payload) {
  return await axiosMain?.post(`${API_URL?.kendra.getkendraList}`, payload);
}
// kendra get  website
export async function getKendraListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.kendra.getkendraList}`, payload);
}

// staus change kendara
export async function KendaraStatusChange(statusChangeObj) {
  return await axioAdmin?.get(
    `${API_URL?.kendra.changestatus}?id=${statusChangeObj?.id}&status=${statusChangeObj?.status}`
  );
}

// staus change kendara
export async function bulkKendaraDelete(data) {
  return await axioAdmin?.delete(
    `${API_URL?.kendra.bulkkendradelete}`, { data }
  );
}


// add kendra
export async function addKendraFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.kendra.addkendra}`, payload
  );
}

// add Banner
export async function addBannerFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.banner.addbanner}`, payload
  );
}

// get Banner
export async function getListOfBanner(payload) {
  return await axioAdmin?.post(
    `${API_URL?.banner.getbanner}`, payload
  );
}
// delete Banner
export async function deleteBannerList(body) {
  return await axioAdmin?.post(
    `${API_URL?.banner.changeStatus}`, body
  );
}
// get Banner for website
export async function getListOfBannerWebsite(payload) {
  return await axiosMain?.post(
    `${API_URL?.banner.getbanner}`, payload
  );
}

// banner status change
export async function bannerStatusChange(statusChangeObj) {
  return await axioAdmin?.post(
    `${API_URL?.banner.changeStatus}`, statusChangeObj
  );
}


// add image
export async function addImageFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.image.addimage}`, payload
  );
}

// get image
export async function getListOfImage(payload) {
  return await axioAdmin?.post(
    `${API_URL?.image.getimage}`, payload
  );
}
export async function getListOfImageforweb(payload) {
  return await axiosMain?.post(
    `${API_URL?.image.getimage}`, payload
  );
}

// delete image
export async function deleteImageFromAdmin(id) {
  return await axioAdmin?.delete(
    `${API_URL?.image.deleteimage}/${id}`
  );
}


// admin profile change
export async function adminProfileChange(payload) {
  return await axioAdmin?.put(
    `${API_URL?.pmbiUser.changeprofile}`, payload
  );
}
// Web user profile change
export async function UserProfileChange(payload) {
  return await axiosMain?.post(
    `${API_URL?.userAuth.changeUserProfile}`, payload
  );
}

// admin profile get
export async function adminProfileget(id) {
  return await axioAdmin?.get(
    `${API_URL?.pmbiUser.getadminprofile}?id=${id}`
  );
}

//get All Kendra 
export async function getAllKendra(payload) {
  return await axiosMain?.post(`${API_URL?.kendra?.getkendraListWeb}`, payload);
}

//get All Kendra 
export async function getAllKendraCount(payload) {
  return await axiosMain?.get(`${API_URL?.kendra?.getKendraCount}`, payload);
}

//  admin change password
export async function passwordChangeAdmin(payload) {
  return await axiosMain?.post(`${API_URL?.pmbiUser?.changepassword}`, payload);
}


// get  mediaevent  list
export async function getAllMediaEventList(payload) {
  return await axiosMain?.post(`${API_URL?.media?.getAllMediaEvent}`, payload);
}
// get pmjayhospital  list
export async function getAllHospitalList(payload) {
  return await axiosMain?.post(`${API_URL?.hospitallist?.getAllHospital}`, payload);
}
//download prodectPdf
export async function getDistributorList(payload) {
  return await axiosMain?.post(`${API_URL?.distributor?.getAllDistributor}`, payload);
}
// get Banner website
export async function getAllListOfBanner(payload) {
  return await axiosMain?.post(
    `${API_URL?.banner.getbanner}`, payload)
}

//web notification
export async function getNotification(body) {
  return await axiosMain?.post(
    `${API_URL?.applyKendra?.notification}`, body
  );
}
export async function seenNotification(notificationId, status) {
  return await axiosMain?.post(
    `${API_URL?.applyKendra?.notificationSeen}?notificationId=${notificationId}&status=${status}`
  );
}
// chnage web password
export async function changePassword(body) {
  return await axiosMain?.post(
    `${API_URL?.pmbiUser?.changepassword}`, body
  );
}

//Annual Report
export async function getAnnualAndFinenicalReport(payload) {
  return await axiosMain?.post(
    `${API_URL?.annualAndFinancialReport?.getAnnualReport}`, payload
  );
}

//NewsLetter
export async function getWhatsNewAndNewsLetter(payload) {
  return await axiosMain?.post(
    `${API_URL?.whatsNewAndNewsletter?.getWhatsnewAndNews}`, payload
  );
}
export async function getWhatsNewAndNewsLetterById(id) {
  return await axiosMain?.post(
    `${API_URL?.whatsNewAndNewsletter?.getWhatsnewAndNewsById}?id=${id}`
  );
}
// Scheme launch
export async function getAllHomeImageData(payload) {
  return await axiosMain?.post(
    `${API_URL?.image.getimage}`, payload
  );
}

// get image
export async function getListOfManagmentTeamAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.managament.getManagament}`, payload
  );
}

// delete management 
export async function deleteManagementItem(id) {
  return await axioAdmin?.delete(
    `${API_URL?.managament.deleteManagement}?id=${id}`
  );
}
// change Image Status
export async function imageStatusChange(id, status) {
  return await axioAdmin?.post(
    `${API_URL?.managament.changeImageStatus}?id=${id}&imageIsActive=${status}`
  );
}

// add managament list
export async function addManagamentFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.managament.addManagament}`, payload
  );
}

// add what's/news 
export async function addWhatsnewOrNewsFromAdmin(payload) {
  return await axioAdmin?.post(
    `${API_URL?.news.AddAndUpdate}`, payload
  );
}


// add event calander 
export async function addEventCalander(payload) {
  return await axioAdmin?.post(
    `${API_URL?.event.addEventInCalander}`, payload
  );
}

// add event calander 
export async function addEventGallery(payload) {
  return await axioAdmin?.post(
    `${API_URL?.event.addEventInGallery}`, payload
  );
}


// get event calander 
export async function getEventGallery(payload) {
  return await axioAdmin?.post(
    `${API_URL?.event.getEventGallery}`, payload
  );
}


// get event gallery for website 
export async function getEventGallerywebiste(payload) {
  return await axiosMain?.post(
    `${API_URL?.event.getEventGallery}`, payload
  );
}

// get event calander 
export async function getEventCalander(payload) {
  return await axioAdmin?.post(
    `${API_URL?.event.getEventCalander}`, payload
  );
}

// get news
export async function getWhatsNewAndNews(payload) {
  return await axioAdmin?.post(`${API_URL?.news.getNewsList}`, payload);
}


// get reports
export async function getReportsFromAdmin(payload) {
  return await axioAdmin?.post(`${API_URL?.reports.getReports}`, payload);
}

// add Report
export async function addReports(payload) {
  return await axioAdmin?.post(
    `${API_URL?.reports.addReports}`, payload
  );
}

//KendraAndVisiterCount
export async function getKendraVisiterCount() {
  return await axiosMain?.get(
    `${API_URL?.kendraAndVisterCount?.visiterAndKendraCount}`
  );
}
export async function getAllDeleteTender(payload) {
  return await axiosMain?.post(`${API_URL?.Archive?.getAllDeleteTenderList}`, payload);
}
export async function getAllDeleteDebarred(payload) {
  return await axiosMain?.post(`${API_URL?.Archive?.getAllDeleteDebarredList}`, payload);
}
export async function getAllDeleteBlackList(payload) {
  return await axiosMain?.post(`${API_URL?.Archive?.getAllDeleteBlackList}`, payload);
}
export async function getAllDeleteReportsList(payload) {
  return await axiosMain?.post(`${API_URL?.Archive?.getAllDeleteReportByType}`, payload);
}
export async function getAllDeleteImage(payload) {
  return await axiosMain?.post(`${API_URL?.Gallery?.getAllDeleteImageList}`, payload);
}

export async function getAllDeleteImageArchives(payload) {
  return await axiosMain?.post(`${API_URL?.Gallery?.getAllDeleteImageArchive}`, payload);
}

export async function getGalleryData(payload) {
  return await axiosMain?.post(`${API_URL?.event?.getEventGallery}`, payload);
}
export async function getAllDeleteRevocationListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.revocation?.getAllDeleteRevocationList}`, payload);
}
export async function getAllDeleteAwarededListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.awarded?.getAllDeleteAwardedList}`, payload);
}

// delete post Job
export async function getDeleteJobListWeb(payload) {
  return await axiosMain?.post(`${API_URL?.recuritment.getDeleteListOfJobWebSite}`, payload);
}

//get All Kendra 
export async function getAllNearByKendra(payload) {
  return await axiosMain?.post(`${API_URL?.kendra?.getAllNearByKendra}`, payload);
}

// get all pacs registration number
export async function getPacsRegistrationNoList(stateCode, key = "yfZKqSc4piibq6U",) {
  return await axiosMain?.post(`${API_URL?.kendra?.getAllPacsRegistrationNumber}?state=${JSON?.parse(stateCode)}&sector=${1}`);
}

//get Admin All Kendra 
export async function getAdminAllNearByKendra(payload) {
  return await axioAdmin?.post(`${API_URL?.kendra?.getAllNearByKendra}`, payload);
}

// map api
export async function getMapAddress(state, district, block, area, pinCode) {
  return await axios?.get(
    `https://geocode.search.hereapi.com/v1/geocode?q=${block}+${area}+${district}+${state}+${pinCode}&in=countryCode:IND&apiKey=${API_URL?.apiKey}`
  );
}
export async function getReverseGeoAddress(lat, long) {
  return await axios?.get(
    `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${lat}%2C${long}&lang=en-US&apiKey=${API_URL?.apiKey}`
  );
}

export async function getYoutubeVideo() {
  return await axios?.get(
    `${API_URL?.youtube?.LatestYoutubevideo}?part=snippet&channelId=${API_URL?.youtubeChannelID}&maxResults=10&key=${API_URL?.youtubeApiKey}&order=date`
  );
}


export async function getSuccessStroyYoutubeVideo() {
  return await axios?.get(
    `${API_URL?.youtube?.successStory}?part=snippet&playlistId=${API_URL?.youtubePlaylistIDSuccessStroy}&maxResults=10&key=${API_URL?.youtubeApiKey}&order=date`
  );
}
